import { render, staticRenderFns } from "./FlashProduct.vue?vue&type=template&id=63126baa&scoped=true&"
import script from "./FlashProduct.vue?vue&type=script&lang=js&"
export * from "./FlashProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63126baa",
  null
  
)

export default component.exports